import { render, staticRenderFns } from "./jzzs.vue?vue&type=template&id=be0fb790&scoped=true&"
import script from "./jzzs.vue?vue&type=script&lang=js&"
export * from "./jzzs.vue?vue&type=script&lang=js&"
import style0 from "./jzzs.vue?vue&type=style&index=0&id=be0fb790&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0fb790",
  null
  
)

export default component.exports